<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- G100系共通部品_Steps -->
    <app-g100-steps></app-g100-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag">事例紹介記事の登録</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- お知らせ登録(j203)) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="j203InputForm">
        <!-- お知らせ情報 -->
        <div class="information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
              <label class="warning">【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
            </label>
          </div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>事例紹介記事の概要</h2>
          </div>
          <!-- お知らせ情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- タイトル -->
              <tr>
                <td class="item-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="j203InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 記事URL -->
              <tr>
                <td class="item-name">
                  掲載URL
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="article_url" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="j203InputForm.get('article_url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- お知らせ内容 -->
              <tr>
                <td class="item-name">
                  記事概要
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="description"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="j203InputForm.get('description')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 図・写真 -->
              <tr>
                <td class="item-input-name">記事サムネイル</td>
                <td class="item-information">
                  <div class="warning-text">
                    ※課題の補足情報として、
                    <label class="warning">5MB</label>
                    以下の図又は写真が添付可能です。
                  </div>
                  <p-fileUpload
                    #image
                    [chooseLabel]="'ファイルを選択'"
                    [cancelLabel]="'キャンセル'"
                    [showUploadButton]="false"
                    fileLimit="1"
                    (onSelect)="uploadFile($event, image, 'article_image')"
                    (onRemove)="deleteFile('article_image')"
                    (onClear)="deleteFile('article_image')"
                  >
                    <ng-template pTemplate="content">
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="articleImgId"
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="searchResultsList.article_image.file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ searchResultsList.article_image.name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('article_image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="p-fileupload-files ng-star-inserted"
                        *ngIf="
                          !articleImgId &&
                          retouchFlg &&
                          file_path?.length != 0 && file_path != undefined
                        "
                      >
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image">
                              <img
                                [src]="file_path"
                                width="50"
                                class="ng-star-inserted"
                                alt="image"
                              />
                            </div>
                            <div>{{ file_name }}</div>
                            <div></div>
                            <div>
                              <button
                                type="button"
                                icon="pi pi-times"
                                pbutton=""
                                ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only"
                                (click)="deleteFile('article_image')"
                              >
                                <span
                                  class="p-button-icon pi pi-times"
                                  aria-hidden="true"
                                ></span>
                                <span aria-hidden="true" class="p-button-label"
                                >&nbsp;</span
                                >
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="j203InputForm.get('article_image')"
                  ></app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!j203InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="j203InputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア [disabled]="!j203InputForm.valid"-->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1"
          [disabled]="!j203InputForm.valid" (click)="moveJ204()"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- お知らせ登録確認(G104)) -->
    <div *ngIf="confirmationFlag">
      <!-- お知らせ情報 -->
      <div class="subcommittee-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録する」ボタンを押して下さい。
        </div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>お知らせの概要</h2>
        </div>
        <!-- お知らせ情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- タイトル -->
            <tr>
              <td class="item-name">
                タイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ j203InputForm.value.title }}
              </td>
            </tr>
            <!-- お知らせ内容 -->
            <tr>
              <td class="item-name">
                お知らせ内容
              </td>
              <td class="item-information">
                {{ j203InputForm.value.description }}
              </td>
            </tr>
            <!-- 掲載URL -->
            <tr>
              <td class="item-name">
                記事URL
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ j203InputForm.value.article_url }}
              </td>
            </tr>
            <!-- サムネイル -->
            <tr>
              <td class="item-name">記事サムネイル</td>
              <td class="item-information img-contents">
                <!-- 図・写真 -->
                <div
                  class="view-size"
                  *ngIf="file_path?.length != 0 && file_path != undefined"
                >
                  <img [src]="file_path" alt="image" id="image" />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="登録する" class="button-default-size button1" (click)="moveJ205()"></button>
        <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveJ203()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
